module.exports = __webpack_public_path__ + "img/alert.22e0ad93.svg";